const API_BASE = "/api/v1";

async function apiRequest(path, init) {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(init && init.headers ? init.headers : {}) },
    ...(init || {}),
  });
  if (!res.ok) {
    if (res.status === 401 && typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
      window.location.replace("/login?reason=session_expired");
    }
    const text = await res.text();
    let message = text || `Request failed: ${res.status}`;
    try {
      const parsed = JSON.parse(text);
      message = parsed.error || parsed.message || message;
    } catch (e) {
      /* plain text */
    }
    throw new Error(message);
  }
  return res.json();
}

export function getHealth() {
  return apiRequest("/health");
}

export function getKpi() {
  return apiRequest("/dashboard/kpi");
}

export function getTokenStatus() {
  return apiRequest("/token/status");
}

export function getStrategyFleet(query) {
  const qs = new URLSearchParams();
  if (query && query.date_from) qs.set("date_from", query.date_from);
  if (query && query.date_to) qs.set("date_to", query.date_to);
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiRequest(`/strategy/fleet${suffix}`);
}

export function getTrades(query) {
  const qs = new URLSearchParams();
  if (query && query.date_from) qs.set("date_from", query.date_from);
  if (query && query.date_to) qs.set("date_to", query.date_to);
  if (query && query.limit) qs.set("limit", String(query.limit));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiRequest(`/trades${suffix}`);
}

export function getMarketSnapshot() {
  return apiRequest("/market/snapshot");
}

export function getLogs(limit, level) {
  const qs = new URLSearchParams();
  if (limit) qs.set("limit", String(limit));
  if (level) qs.set("level", level);
  return apiRequest(`/logs?${qs.toString()}`);
}

export function getDecisions(query) {
  const qs = new URLSearchParams();
  if (query && typeof query === "object") {
    if (query.n) qs.set("n", String(query.n));
    if (query.date_from) qs.set("date_from", query.date_from);
    if (query.date_to) qs.set("date_to", query.date_to);
    if (query.phase) qs.set("phase", query.phase);
  } else if (query) {
    qs.set("n", String(query));
  }
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiRequest(`/decisions${suffix}`);
}

export function getFleetTrades(query) {
  const qs = new URLSearchParams();
  if (query && query.strategy_id) qs.set("strategy_id", query.strategy_id);
  if (query && query.date_from) qs.set("date_from", query.date_from);
  if (query && query.date_to) qs.set("date_to", query.date_to);
  if (query && query.limit) qs.set("limit", String(query.limit));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return apiRequest(`/strategy/fleet/trades${suffix}`);
}

export function enableStrategyLive(strategyId, csrfToken) {
  return apiRequest(`/strategy/fleet/${encodeURIComponent(strategyId)}/live/enable`, {
    method: "POST",
    body: JSON.stringify({ csrf_token: csrfToken }),
  });
}

export function disableStrategyLive(strategyId, csrfToken) {
  return apiRequest(`/strategy/fleet/${encodeURIComponent(strategyId)}/live/disable`, {
    method: "POST",
    body: JSON.stringify({ csrf_token: csrfToken }),
  });
}

export function todayIST() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
}

export function fmtCurrency(v) {
  return `Rs ${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
}

export function fmtAvgPnl(value, count) {
  if (!count) return "—";
  return fmtCurrency(value);
}

export function fmtDateTime(v) {
  if (!v) return "-";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString("en-IN", { hour12: false });
}

export function pnlClass(v) {
  if (v > 0) return "text-success";
  if (v < 0) return "text-danger";
  return "text-muted";
}
